const configurationVersion = 1;

export default configurationVersion;
